import React, { useState } from 'react';

const ProductForm = ({ product, onSubmit, onCancel, categories = [] }) => {
  const [formData, setFormData] = useState(product || {
    name: '',
    description: '',
    price: '',
    category: '',
    emoji: ''
  });
  // removed image upload to simplify flow; keep emoji only

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Only submit emoji and other fields; ignore any image
    onSubmit({ ...formData });
  };

  // Emoji picker local (sin dependencias)
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);

  const emojiGroups = {
    frutas: ['🍎','🍌','🍓','🥭','🍍','🍇','🍉'],
    verduras: ['🥬','🥕','🥒','🌶️','🥦'],
    tropical: ['🏝️','🥥','🍍','🌴'],
    bebidas: ['🥤','🧃','🍹','🧋'],
    otros: ['🍯','🥛','🍯','🍋','🍊','☀️']
  };

  const selectEmoji = (emoji) => {
    setFormData(prev => ({ ...prev, emoji }));
    setShowEmojiPicker(false);
  };

  // image upload removed to avoid storage issues

  return (
    <div className="bg-white rounded-xl shadow-md p-6">
      <h3 className="text-xl font-bold text-gray-800 mb-4">
        {product ? 'Editar Producto' : 'Nuevo Producto'}
      </h3>
  <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label className="block text-gray-700 mb-2">Nombre</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
            required
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 mb-2">Descripción</label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            rows="3"
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
            required
          />
        </div>
        <div className="grid grid-cols-2 gap-4 mb-4">
          <div>
            <label className="block text-gray-700 mb-2">Precio ($)</label>
            <input
              type="number"
              name="price"
              value={formData.price}
              onChange={handleChange}
              min="0"
              step="0.01"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
              required
            />
          </div>
          <div>
            <label className="block text-gray-700 mb-2">Categoría</label>
            <select
              name="category"
              value={formData.category}
              onChange={handleChange}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
              required
            >
              <option value="">Seleccionar</option>
              {categories.map(cat => (
                <option key={cat.name} value={cat.name}>
                  {cat.description ? `${cat.name} — ${cat.description}` : cat.name}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="mb-6">
          <label className="block text-gray-700 mb-2">Emoji</label>
          <div className="flex items-center space-x-2">
            <input
              type="text"
              name="emoji"
              value={formData.emoji}
              onChange={handleChange}
              className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
              required
            />
            <button
              type="button"
              onClick={() => setShowEmojiPicker(true)}
              className="px-3 py-2 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
            >
              Seleccionar
            </button>
            <div className="text-2xl">{formData.emoji || '—'}</div>
          </div>
        </div>

        {/* Imagen deshabilitada temporalmente; solo se guarda el emoji */}

        {showEmojiPicker && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-lg">
              <div className="flex justify-between items-center mb-4">
                <h4 className="text-lg font-semibold">Selecciona un emoji</h4>
                <button onClick={() => setShowEmojiPicker(false)} className="text-gray-600">✕</button>
              </div>
              <div className="space-y-4">
                {Object.entries(emojiGroups).map(([group, list]) => (
                  <div key={group}>
                    <h5 className="text-sm font-medium text-gray-700 mb-2 capitalize">{group}</h5>
                    <div className="grid grid-cols-8 gap-2">
                      {list.map(e => (
                        <button
                          key={e}
                          type="button"
                          onClick={() => selectEmoji(e)}
                          className="p-2 rounded hover:bg-gray-100 text-2xl"
                        >
                          {e}
                        </button>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
        <div className="flex justify-end space-x-3">
          <button
            type="button"
            onClick={onCancel}
            className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-100 transition-colors"
          >
            Cancelar
          </button>
          <button
            type="submit"
            className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
          >
            {product ? 'Actualizar' : 'Agregar'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default ProductForm;